import React, { FC } from 'react';
import Paragraph from '../../ui/Typography/Paragraph';

interface IProps {
  message: string;
}

const SystemDescription: FC<IProps> = ({ message }) => {
  return (
    <Paragraph fontSize="12" align="center">
      {message}
    </Paragraph>
  );
};

export default SystemDescription;
